import { sameValueForEveryLocale } from "../../utils/sameValueForEveryLocale.js";
import type { Locale } from "../Locale.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getGdprPath(locale: Locale): string {
	const pathMap = sameValueForEveryLocale("/gdpr");
	return getPathInLocale(locale, pathMap);
}
